export const meta = {
  title: 'Promotions: discounts that apply themselves',
  updatedAt: '2026-07-17',
  related: ['loyalty', 'broadcasts', 'pos'],
};

Vouchers are handed out one customer at a time; promotions switch on and work the door for you. While a promotion is live, its discount applies automatically the moment a customer books — no code to type, nothing for your cashier to remember.

## The two templates

Open **Promotions** under the Promos menu and tap **New promotion**. Two templates ship today:

- **Day-of-Week** — pick one or more days, e.g. _Member Tuesday: 20% off every Tuesday, all day_.
- **Happy Hour** — a daily time window, e.g. _17:00–19:00, 15% off_.

Both take a name (customers see it next to their savings), a discount as **% off the whole cart**, and a validity range — by default from today for three months. New promotions go live the moment you save.

Being upfront about the edges: everything you can build in the form today is a percentage off the whole cart, at every outlet, for every vehicle type. The engine underneath understands more — minimum spend, per-outlet targeting, redemption caps, RM-off amounts, free add-ons — but there's no dashboard screen to set those yet, so they're not options you can configure.

## How the discount lands

The discount is worked out when the customer books, on the cart subtotal (package plus add-ons). It shows as its own savings line — the customer sees it in their app, and your cashier sees it read-only on the POS payment sheet. If more than one live promotion could apply, the customer gets the **single best one** — promotions don't stack with each other or with vouchers; whichever single deal saves the most wins.

## Draft one with AI

Tap **AI draft** and describe what you want in a sentence — _"Saturday morning happy hour, RM 5 off, 7am to 10am"_. The assistant proposes a complete promotion: template, discount, validity. Nothing goes live until you review the preview and hit publish, and you can discard it without a trace. (This is also the one way to create an RM-off promotion today — the manual form is %-only.) If the network's AI assistant isn't switched on yet, the panel tells you so instead of guessing.

## Pause, archive, and the numbers

Every promotion row carries its status and real numbers from your tickets: how many times it was redeemed, the total it gave away, and when it last fired. Pause an active promotion any time — the discount stops immediately and you can resume it later. Archiving retires it for good; the row stays for your records.

The AI assistant can additionally draft an always-on promotion — a shape the manual form does not offer yet.
